import React from 'react';
import { KatanaPathDumpRow } from '@/types';
import { advancedToggleColumnKeys, columns, defaultLimit } from './constants';

type ColumnSettingsProps = {
  hiddenColumns: Set<keyof KatanaPathDumpRow>;
  onToggleColumn: (key: keyof KatanaPathDumpRow) => void;
  onToggleAdvancedColumns: () => void;
  showColumnControls: boolean;
  limitInput: number;
  onLimitChange: (value: number) => void;
};

export const ColumnSettings: React.FC<ColumnSettingsProps> = ({
  hiddenColumns,
  onToggleColumn,
  onToggleAdvancedColumns,
  showColumnControls,
  limitInput,
  onLimitChange,
}) => {
  const visibleCount = columns.length - hiddenColumns.size;

  return (
    <details>
      <summary className="fw-semibold" style={{ cursor: 'pointer' }}>
        Advanced Settings
      </summary>
      <div className="border rounded p-2 mt-2">
        <div className="mb-3">
          <label className="form-label mb-1">Limit</label>
          <input
            className="form-control"
            type="number"
            min={1}
            max={1000}
            value={limitInput}
            onChange={(evt) => onLimitChange(Number(evt.target.value || defaultLimit))}
          />
        </div>

        {showColumnControls && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-muted">
                Showing {visibleCount} of {columns.length} columns
              </small>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={onToggleAdvancedColumns}
              >
                {advancedToggleColumnKeys.every((key) => hiddenColumns.has(key))
                  ? 'Show Technical Columns'
                  : 'Hide Technical Columns'}
              </button>
            </div>

            <div
              className="d-flex flex-wrap gap-3"
              style={{ maxHeight: 220, overflowY: 'auto' }}
            >
              {columns.map((column) => {
                const checked = !hiddenColumns.has(column.key);
                return (
                  <label key={column.key} className="form-check-label small">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={checked}
                      onChange={() => onToggleColumn(column.key)}
                    />
                    {column.label}
                  </label>
                );
              })}
            </div>
          </>
        )}

        {!showColumnControls && (
          <small className="text-muted d-block">
            Column visibility controls are available in Rows view.
          </small>
        )}
      </div>
    </details>
  );
};
